export default __webpack_public_path__ + "static/media/profile.f53052de.JPG";